import { Button, Flex, Text, TextField } from '@workos-inc/design-system';
import { Form } from 'radix-ui';
import * as React from 'react';
const DemoFormRoot = React.forwardRef<React.ElementRef<typeof Form.Root>, React.ComponentPropsWithoutRef<typeof Form.Root>>((props, forwardedRef) => <Form.Root ref={forwardedRef} {...props} />);
DemoFormRoot.displayName = 'DemoFormRoot';
const DemoFormField = React.forwardRef<React.ElementRef<typeof Flex>, React.ComponentPropsWithoutRef<typeof Flex> & {
  name: string;
}>(({
  name,
  children,
  ...props
}, forwardedRef) => <Form.Field ref={forwardedRef} asChild name={name}>
    <Flex ref={forwardedRef} direction="column" gap="1" {...props}>
      {children}
    </Flex>
  </Form.Field>);
DemoFormField.displayName = 'DemoFormField';
const DemoFormLabel = React.forwardRef<React.ElementRef<typeof Form.Label>, Omit<React.ComponentPropsWithoutRef<typeof Form.Label>, 'asChild'>>(({
  children,
  ...props
}, forwardedRef) => <Form.Label ref={forwardedRef} {...props}>
    <Text size="2" trim="start" weight="bold">
      {children}
    </Text>
  </Form.Label>);
DemoFormLabel.displayName = 'DemoFormLabel';
const DemoFormInput = React.forwardRef<React.ElementRef<typeof TextField.Root>, React.ComponentPropsWithoutRef<typeof TextField.Root>>(({
  invalid,
  // TODO: Remove `state` prop when it's removed from `TextField`
  state,
  ...props
}, forwardedRef) => <Form.ValidityState>
      {validity => <Form.Control asChild>
          <TextField.Root ref={forwardedRef} invalid={validity?.valid === false} size="3" {...props} />
        </Form.Control>}
    </Form.ValidityState>);
DemoFormInput.displayName = 'DemoFormInput';
const DemoFormMessage = React.forwardRef<React.ElementRef<typeof Form.Message>, Omit<React.ComponentPropsWithoutRef<typeof Form.Message>, 'asChild'>>(({
  children,
  ...props
}, forwardedRef) => <Form.Message ref={forwardedRef} asChild {...props}>
    <Text as="p" color="red" size="2">
      {children}
    </Text>
  </Form.Message>);
DemoFormMessage.displayName = 'DemoFormMessage';
const DemoFormSubmit = React.forwardRef<React.ElementRef<typeof Button>, React.ComponentPropsWithoutRef<typeof Button>>((props, forwardedRef) => <Form.Submit asChild>
    <Button ref={forwardedRef} color="purple" size="3" {...props} />
  </Form.Submit>);
DemoFormSubmit.displayName = 'DemoFormSubmit';
export const DemoForm = {
  Root: DemoFormRoot,
  Field: DemoFormField,
  Label: DemoFormLabel,
  Input: DemoFormInput,
  Message: DemoFormMessage,
  Submit: DemoFormSubmit
};